import { useCallback } from 'react';
import {
  CustomLabelOptionsInput,
  SelectLabelOption,
  useCreateCustomLabelOptionsMutation
} from 'graphql/types';

type CreateCustomLabelOptionReturnValue = {
  loading: boolean;
  createCustomLabelOption: (
    option: CustomLabelOptionsInput
  ) => Promise<SelectLabelOption | undefined>;
};
export const useCreateCustomLabelOption = (): CreateCustomLabelOptionReturnValue => {
  const [
    createCustomLabelOptionsMutation,
    { loading }
  ] = useCreateCustomLabelOptionsMutation();

  const createCustomLabelOption = useCallback(
    async (option: CustomLabelOptionsInput) => {
      const newOption = await createCustomLabelOptionsMutation({
        variables: {
          input: {
            options: [option]
          }
        },
        awaitRefetchQueries: true,
        refetchQueries: ['selectLabelOptions']
      });
      return newOption.data?.createCustomLabelOptions.customLabelOptions[0];
    },
    [createCustomLabelOptionsMutation]
  );

  return {
    loading,
    createCustomLabelOption
  };
};
